import React, { FunctionComponent } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Alert from 'Shared/components/Alert'
import { getAmountOfCampaigns } from 'Redux/selectors/campaigns'
import { createRelaunchCampaign } from 'Redux/actions/campaignActions'
import { CampaignPlatformTypeEnum } from 'Types/index'
import { campaignScheduleStartEvent } from 'Helpers/tagManager'
import { updateScheduledCampaign } from 'Redux/actions/scheduleActions'
import { getUserId } from 'Redux/selectors/auth'
import { RenewCampaignAlertProps } from './RenewCampaignAlertProps'

const RenewCampaignAlert: FunctionComponent<RenewCampaignAlertProps> = ({
  campaign,
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()

  const userId = useSelector(getUserId)
  const amountOfCampaigns = useSelector(getAmountOfCampaigns)

  const handleRelaunchCampaign = (campaign_id: number | string) => {
    const url = window.location.href

    dispatch(
      createRelaunchCampaign(campaign_id, url, (error, res) => {
        if (!error) {
          dispatch(updateScheduledCampaign(res))

          campaignScheduleStartEvent(
            res.type,
            res?.Track?.TrackGenres?.map(el => el.Genre.genre_name).join(),
            res?.Track?.TrackLanguages?.map(
              el => el.Language.language_name
            ).join(),
            res.id,
            CampaignPlatformTypeEnum.SPOTIFY,
            userId,
            amountOfCampaigns,
            res?.is_feed || false
          )
          history.push(`/campaigns/schedule/${res.id}`)
        }
        // TODO catch err
      })
    )
  }

  return (
    <Alert color="warning" icon>
      <div className="alert__text">
        <div className="alert__title">
          {t('campaignsPage.reccomendationFor')} &quot;{campaign.trackTitle}
          &quot;
        </div>
        <div>
          {t('campaignsPage.excellentOpportunity')}
          <br />
          {t('campaignsPage.ourSystem')}
        </div>
      </div>
      <button
        type="button"
        className="warning__btn"
        color="success"
        onClick={() => {
          handleRelaunchCampaign(campaign.id)
        }}
      >
        {t('campaignsPage.relaunchCampaign')}
      </button>
    </Alert>
  )
}

export default RenewCampaignAlert
